<template>
    <b-modal ref="modal" size="xl" centered scrollable title="Dati intervento" ok-title="Esegui intervento" cancel-title="Chiudi" :ok-disabled="!puoEseguire" no-close-on-backdrop @ok="onEsegui" @hidden="reset">
        <b-alert v-if="errore" show variant="danger">{{ errore }}</b-alert>

        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Codice pratica</div>
                <div class="sa-siat-valore-intervento">{{ pratica.codice || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Assistito</div>
                <div class="sa-siat-valore-intervento">{{ formattaValore(pratica.assistito) || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Bisogno</div>
                <div class="sa-siat-valore-intervento">{{ formattaValore(pratica.bisogno) || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Descrizione intervento</div>
                <div class="sa-siat-valore-intervento">{{ pratica.tipoPrestazioneDescrizione || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Numero intervento</div>
                <div class="sa-siat-valore-intervento">{{ jsonData.numeroIntervento || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Data prevista esecuzione</div>
                <div class="sa-siat-valore-intervento">{{ formattaData(jsonData.dataPrevista) || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Data effettiva</div>
                <div class="sa-siat-valore-intervento">{{ formattaData(jsonData.dataEffettiva) || "--" }}</div>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <div class="sa-siat-label-intervento">Stato intervento</div>
                <b-badge :variant="jsonData.statoIntervento === 'ESEGUITO' ? 'success' : 'warning'">
                    {{ jsonData.statoIntervento || "--" }}
                </b-badge>
            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <label class="sa-siat-label-intervento" for="data-effettiva-esecuzione">Data effettiva esecuzione *</label>
                <date-picker id="data-effettiva-esecuzione" v-model="jsonData.dataEffettivaEsecuzione" type="date" format="DD/MM/YYYY" value-type="timestamp" :disabled="jsonData.statoIntervento === 'ESEGUITO'"></date-picker>

            </b-col>

            <b-col cols="12" md="6" class="mb-3">
                <label class="sa-siat-label-intervento" for="ora-effettiva-esecuzione">Ora effettiva esecuzione *</label>
                <b-form-input id="ora-effettiva-esecuzione" v-model="oraEffettivaEsecuzione" type="time" :disabled="jsonData.statoIntervento === 'ESEGUITO'" :state="validazioneAttiva ? !!oraEffettivaEsecuzione : null"></b-form-input>
                <b-form-invalid-feedback>Inserire l'ora effettiva di esecuzione.</b-form-invalid-feedback>
            </b-col>
        </b-row>

        <template #modal-ok>
            <i class="fas fa-check-circle mr-1"></i>
            Esegui intervento
        </template>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin.js";

export default {
    components: { DatePicker },
    data() {
        return {
            pathResource: "/siateventiprestazioniintevalli/aggiornastato",
            pratica: {},
            jsonData: {},
            validazioneAttiva: false,
            errore: null,
            oraEffettivaEsecuzione: "",
        };
    },
    computed: {
        puoEseguire() {
            return this.jsonData.statoIntervento !== "ESEGUITO";
        },
    },
    methods: {
        show(pratica) {
            let me = this;
            me.pratica = { ...pratica };
            me.jsonData = { ...pratica.eventiPrestazioniIntevalliBean };
            let dataEsecuzione = me.jsonData.dataEffettivaEsecuzione ? new Date(me.jsonData.dataEffettivaEsecuzione) : new Date();
            me.jsonData.dataEffettivaEsecuzione = dataEsecuzione.getTime();
            me.oraEffettivaEsecuzione = `${String(dataEsecuzione.getHours()).padStart(2, "0")}:${String(dataEsecuzione.getMinutes()).padStart(2, "0")}`;
            me.$refs.modal.show();
        },
        reset() {
            let me = this;
            me.pratica = {};
            me.jsonData = {};
            me.validazioneAttiva = false;
            me.errore = null;
            me.oraEffettivaEsecuzione = "";
        },
        onEsegui(event) {
            event.preventDefault();
            let me = this;
            me.validazioneAttiva = true;
            me.errore = null;
            if (!me.jsonData.dataEffettivaEsecuzione || !me.oraEffettivaEsecuzione) {
                return;
            }
            let dataEffettivaEsecuzione = new Date(me.jsonData.dataEffettivaEsecuzione);
            let [ore, minuti] = me.oraEffettivaEsecuzione.split(":").map(Number);
            dataEffettivaEsecuzione.setHours(ore, minuti, 0, 0);
            me.jsonData.dataEffettivaEsecuzione = dataEffettivaEsecuzione.getTime();
            me.jsonData.stato = "ESEGUITO";
            me.jsonData.statoIntervento = "ESEGUITO";
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.onSalvataggioSuccess, me.onSalvataggioErrore);
        },
        onSalvataggioSuccess(response) {
            let me = this;
            me.$bvToast.toast("Intervento eseguito con successo.", { variant: "success", solid: true });
            me.$emit("interventoEseguito", response.data);
            me.$refs.modal.hide();
        },
        onSalvataggioErrore(error) {
            let me = this;
            me.errore = error && error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : "Errore durante il salvataggio dell'intervento.";
        },
        formattaData(value) {
            let data = new Date(value);
            return Number.isNaN(data.getTime()) ? value : data.toLocaleString("it-IT");
        },
        formattaValore(value) {
            if (typeof value === "object") {
                return [value.cognome, value.nome].filter(Boolean).join(" ") || value.descrizione || value.value || "--";
            }
            return value;
        },
    },
};
</script>

<style scoped>
.sa-siat-label-intervento {
    display: block;
    color: #6c757d;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
}

.sa-siat-valore-intervento {
    color: #2c3e50;
    font-size: 1rem;
    font-weight: 600;
    overflow-wrap: anywhere;
}

</style>
